import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Button, FlexColumn, IconButton } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

const paddingByVariant = {
    compact: "10px 16px",
    prominent: "20px 24px 12px",
    prominentCompact: "12px 16px 0",
};

const trialPaddingByVariant = {
    compact: "12px 16px",
    prominent: "16px 24px",
    prominentCompact: "12px 16px",
};

export const LowCreditsBannerContainer = styled(FlexColumn)<{
    variant: "compact" | "prominent" | "prominentCompact";
    $isInline?: boolean;
}>`
    padding: ${({ variant, $isInline }) =>
        $isInline && variant === "prominent" ? "16px 24px" : paddingByVariant[variant]};
    border-radius: 4px;
    background: ${colorsPalettes.blue[100]};

    ${({ $isInline }) =>
        $isInline &&
        css`
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 16px;
        `}
`;

export const LowCreditsContent = styled(Stack)`
    gap: 4px;
    min-width: 0;
    flex: 1;
`;

export const LowCreditsDescription = styled(Text)<{ $isInline?: boolean }>`
    margin-top: 4px;
    margin-bottom: ${({ $isInline }) => ($isInline ? "0" : "12px")};
`;

export const LowCreditsButton = styled(Button)`
    width: fit-content !important;
`;

export const TrialLowCreditsBannerContainer = styled(Stack)<{
    variant: "compact" | "prominent" | "prominentCompact";
    isStacked: boolean;
}>`
    gap: 12px;
    padding: ${({ variant }) => trialPaddingByVariant[variant]};
    border-radius: 4px;
    background: ${colorsPalettes.sky[100]};

    ${({ isStacked }) =>
        isStacked
            ? css`
                  align-items: flex-start;
              `
            : css`
                  flex-direction: row;
                  align-items: center;
                  justify-content: space-between;
                  gap: 16px;
              `}
`;

export const TrialLowCreditsContent = styled(Stack)`
    gap: 4px;
    min-width: 0;
`;

export const TrialLowCreditsButton = styled(IconButton)`
    flex-shrink: 0;
`;
